import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import SectionCard from '../../../components/SectionCard';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <SectionCard className="about-text-container">
        <Skeleton variant="text" width="30%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="100%" />
      </SectionCard>
      <Box className="btn-new-appointment">
        <Box className="btn-new-appointment-icon-before">
          <Skeleton variant="circle" width={24} height={24} />
        </Box>
        <Box className="btn-new-appointment-text">
          <Skeleton variant="text" width="200px" />
        </Box>
        <Box className="btn-new-appointment-icon-after">
          <Skeleton variant="circle" width={24} height={24} />
        </Box>
      </Box>
    </Box>
  );
};

export default Loading;
